<template>
    <b-modal
        v-model="modalSearchClient"
        size="lg"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">Confirmar Pedido</div>
        </template>
        <b-row>
            <b-col cols="12">
                <p class="font-weight-medium">Por favor seleccione el tipo de documento e ingrese el número para continuar.</p>
            </b-col>
            <b-col cols="12" sm="6">
                <label for="departamento">Tipo Documento</label>
                    <b-form-group>
                        <b-form-select
                        v-model="datosCliente.tipo_documento"
                        :options="tipoDocumento"
                        id="departamento"
                        class="mb-3"
                        value-field="tipo"
                        text-field="label"
                        >
                        <template #first>
                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" sm="6">
                <label for="nit">Número de Documento</label>
                <b-form-input id="nit" v-model="datosCliente.documento" @kkeydown.enter.prevent="searchClientData()" placeholder="Número Documento"></b-form-input>
            </b-col>
            <b-col cols="12">
                <b-alert show variant="danger" v-if="errorValidate">
                    <ul >
                        <li v-for="(item, index) in searchClientErrors" :key="index">{{ item }}</li>
                    </ul>
                </b-alert>
            </b-col>
        </b-row>
        <template v-slot:modal-footer>
            <b-button variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
            </b-button>
            <b-button variant="success" @click.prevent="searchClientData()">
                Consultar
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import {  mapMutations } from 'vuex'
export default {
    name: "SearchClientModal",
    props: {
        modalSearchClient: {
            type: Boolean
        },
        datosCliente: {
            type: Object
        },
        tipoDocumento: {}
    },
    data(){
        return{
            searchClientErrors: [],
            errorValidate: false,
            clientData: {}
        }
    },
    methods: {
        ...mapMutations(['setLoading']),
        async searchClientData(){
            this.setLoading(true)
            this.searchClientErrors = [];
            this.errorValidate = false;
            await this.$conectar.post('cart/get-cliente-empresa-by-user', this.datosCliente)
            .then(response =>{
                if(response.data.errors){
                    this.searchClientErrors = response.data.errors;
                    this.errorValidate = true;
                }else{
                    if(response.data.error == false){
                        this.clientData = response.data.mensaje;
                    }else{
                        this.clientData.tipo_documento = this.datosCliente.tipo_documento;
                        this.clientData.documento = this.datosCliente.documento;
                    }
                    this.$emit('open-client-form-modal', this.clientData);
                }
                
                
            })
            .catch(e =>{
                console.log(e);
            })
            this.setLoading(false)
        },
    }
};

</script>
<style scoped>

</style>